import { NSARouterMakerResult } from "namirasoft-account-react";
import { FieldEntities } from "../FieldEntities";
import { FieldLayout } from "../FieldLayout";
import { FieldProps } from "../FieldProps";

interface FieldViewPageProps extends NSARouterMakerResult, FieldProps
{ }

export default function FieldViewPage(props: FieldViewPageProps)
{
	return (
		<FieldLayout
			{...props}
			action={{
				description: "This section displays detailed information about a selected field."
			}}
			pages={{
				entity: FieldEntities.field(props),
				view: {}
			}}
		>
			<> </>
		</FieldLayout>
	);
}